import { Stack, Title, Paper } from '@mantine/core'
import { PasskeysSection } from './PasskeysSection'

export function SettingsView() {
  return (
    <Stack gap="xl">
      <div>
        <Title order={2}>Settings</Title>
      </div>

      <div>
        <Title order={4} mb="xs">
          Security
        </Title>
        <Paper withBorder p="lg" radius="md">
          <PasskeysSection />
        </Paper>
      </div>
    </Stack>
  )
}
